module.exports = __webpack_public_path__ + "img/discovery.9b9ac544.png";